import classNames from "classnames";
import styles from "./FeatureFilterItem.module.scss";

import RADIO from "assets/icon/btn/icon_btn_radio.svg";
import RADIO_ACTIVE from "assets/icon/btn/icon_btn_radio_active.svg";
import { TEXT_TYPES } from "./types/text.type";

type FeatureFilterItemProps = {
  labelKey: string;
  count: number;
  selectedState: string;
  currentState: string;
  colorClass: string;
  onClick: () => void;
};
export const FeatureFilterItem = ({
  labelKey,
  count,
  selectedState,
  currentState,
  colorClass,
  onClick,
}: FeatureFilterItemProps) => {
  const isSelected = selectedState === currentState;
  const label = labelKey;

  return (
    <div
      className={classNames(
        styles["__feature-filter"],
        labelKey === "TOTAL" && styles["__with-border-top"]
      )}
    >
      <div
        className={classNames(
          styles["radio-button"],
          isSelected && styles["__selected"]
        )}
        onClick={onClick}
      >
        <img src={isSelected ? RADIO_ACTIVE : RADIO} />
      </div>
      <div className={classNames(TEXT_TYPES["BODY1"], styles["__label"])}>
        {labelKey !== "TOTAL" && (
          <span
            className={classNames(styles["color-box"], styles[colorClass])}
          ></span>
        )}
        <span>{label}</span>
      </div>
      <div className={classNames(styles["__count"], TEXT_TYPES["H4_700"])}>
        {count}
      </div>
    </div>
  );
};
